var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAutoRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3484_8396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 28.0001V30.3868C36 30.9868 36.72 31.2801 37.1333 30.8534L40.8533 27.1334C41.12 26.8668 41.12 26.4534 40.8533 26.1868L37.1333 22.4668C36.72 22.0534 36 22.3468 36 22.9468V25.3334C30.1066 25.3334 25.3333 30.1068 25.3333 36.0001C25.3333 37.3868 25.6 38.7201 26.0933 39.9334C26.4533 40.8268 27.6 41.0668 28.28 40.3868C28.64 40.0268 28.7866 39.4801 28.5866 39.0001C28.2 38.0801 28 37.0534 28 36.0001C28 31.5868 31.5866 28.0001 36 28.0001ZM43.72 31.6134C43.36 31.9734 43.2133 32.5334 43.4133 33.0001C43.7866 33.9334 44 34.9468 44 36.0001C44 40.4134 40.4133 44.0001 36 44.0001V41.6134C36 41.0134 35.28 40.7201 34.8666 41.1468L31.1466 44.8668C30.88 45.1334 30.88 45.5468 31.1466 45.8134L34.8666 49.5334C35.28 49.9468 36 49.6534 36 49.0667V46.6668C41.8933 46.6668 46.6666 41.8934 46.6666 36.0001C46.6666 34.6134 46.4 33.2801 45.9066 32.0668C45.5466 31.1734 44.4 30.9334 43.72 31.6134Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3484_8396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoRenew);
export default __webpack_public_path__ + "static/media/IconAutoRenew.23f33a8245eb36c79e030701e4e4e72c.svg";
export { ForwardRef as ReactComponent };